import { ApiHosts, handleResponseOld, makeGet } from '@/redux/api/helpers';
import { SellerDetails } from '@/types/SellerDetails';

/**
 * @category Item API
 * @see getSellerEndedCatalogsById
 */
type GetSellerDetailsByIdsParams = {
    deployment: string;
    sellerIds: number[];
};

export type GetSellerDetailsByIdsResponse = {
    data: {
        sellerDetails: SellerDetails[];
    };
    message: string;
    success: boolean;
};

/**
 * fetches seller detail by given sellerId via Post request to Item API service
 * @function GetSellerDetailsByIdsParams
 * @category Item API
 * @param {GetSellerDetailsByIdsParams}
 * @see https://item-api-DEPLOYMENT.liveauctioneers.com/small/seller-detail
 * @see https://github.com/LIVEauctioneers/item-api/blob/master/src/inventory/routes/post-seller-detail.ts
 */
export const getSellerDetailsByIds = ({ deployment, sellerIds }: GetSellerDetailsByIdsParams) =>
    new Promise<GetSellerDetailsByIdsResponse>((resolve, reject) => {
        const request = makeGet({
            apiPath: 'small/seller-detail',
            deployment,
            path: ApiHosts.ItemApi,
            queryParams: {
                ids: sellerIds.join(','),
            },
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
